<template>
  <ul v-if="categories.length" :class="{
      'category_list': preview || allCategoriesView || search,
      'cat_inner': !preview && !allCategoriesView && !search,
      'category_list_tile': tileView,
    }">
    <li v-for="(category, ind) in categories" :key="Date.now() + category.id" :class="'tile'+(ind % 3)">
      <!-- <CategoryItem v-if="isSeeCategory(category)" :category="category" :search="search" :preview="preview"/> -->
      <CategoryItem v-if="category" :category="category" :search="search" :preview="preview"/>
    </li>

  </ul>
</template>

<script>
  import CategoryItem from '@/components/ECommerce/Categories/CategoryItem'

  export default {
    name: 'CategoryList',
    data() {
      return {}
    },
    props: {
      categories: Array,
      search: Boolean,
      preview: Boolean
    },
    components: {CategoryItem},
    watch: {},
    mounted() {

    },
    computed: {
      allCategoriesView() {
        return this.$store.getters.selectedCategory === null || this.$store.getters.selectedCategory.id === null
      },
      tileView() {
        return this.$store.getters.categoryTileView
      }
    },
    methods: {
      isSeeCategory(category) {
        let result = false;

        if (category.dishes_count > 0) {
          result = true
        } else {
          this.$store.getters.categories.forEach(el => {
            if (el.parent_id === category.id && el.dishes_count > 0) {
              result = true
            }
          })
        }
        
        return result
      },
    }
  }
</script>

<style>

.cl_img img {
  -webkit-user-drag: none;
}

.category_list_tile {
  display: flex !important;
  flex-wrap: wrap;
}
.category_list_tile > li {
  flex: calc(50% - 5px) 0 0;
  position: relative;
  border-bottom: none !important;
  margin-top: 0 !important;
  margin-bottom: 10px;
}
.category_list_tile > li:nth-child(2n+1) {
  margin-right: 10px;
}
.category_list_tile > li:after {
  content: "";
  display: block;
  padding-top: 100%;
  padding-top: 100%;
  border-radius: 16px;
}
.category_list_tile > li.tile0:after {  background: linear-gradient(180deg, rgba(0, 132, 255, 0.35) 1.56%, rgba(0, 132, 255, 0.69) 43.75%, #0084FF 100%); }
.category_list_tile > li.tile1:after {  background: linear-gradient(180deg, rgba(226, 136, 0, 0.35) 1.56%, rgba(226, 136, 0, 0.69) 43.75%, #E28800 100%); }
.category_list_tile > li.tile2:after {  background: linear-gradient(180deg, rgba(209, 39, 237, 0.35) 1.56%, rgba(209, 39, 237, 0.69) 43.75%, #D127ED 100%); }
/* .category_list_tile > li.tile3:after {  background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.12) 48.44%, rgba(0, 0, 0, 0.79) 99.99%); } */

.category_list_tile > li a {
  position: absolute !important;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  cursor: pointer;
}

.category_list_tile > li a.cat_inner_href,
.category_list_tile > li a.cat_inner_block {
  border-bottom: none !important;
  height: auto !important;
} 

.category_list_tile .cl_name {
  font-weight: 700 !important;
  font-size: 14px !important;
  line-height: 17px !important;
  color: #fff !important;
  position: absolute;
  left: 0px;
  bottom: 18px;
  z-index: 3;
}

.category_list_tile .cl_img {
  height: 100% !important;
  width: 100% !important;
  min-width: 38px;
  border-radius: 16px !important;
  position: absolute;
  z-index: 1;
  top: 0px;
  right: 0px;
}

.category_list_tile .cl_img:after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 2;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.12) 48.44%, rgba(0, 0, 0, 0.79) 99.99%);
}

.category_list_tile .cl_img img {
  z-index: 1;
  border-radius: 16px !important;
  height: 100% !important;
}

</style>